import { render } from "./ui-button-main.vue?vue&type=template&id=5a13d4ee&scoped=true&ts=true"
import script from "./ui-button-main.vue?vue&type=script&lang=ts"
export * from "./ui-button-main.vue?vue&type=script&lang=ts"

import "./ui-button-main.vue?vue&type=style&index=0&id=5a13d4ee&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a13d4ee"]])

export default __exports__